import React from 'react';
import PropTypes from 'prop-types';

const CarouselHeader = (props) => {
    return (
        <div className="hearby-carousel-info">
            <h3>{String(props.title)}</h3>
        </div>

    );
}

CarouselHeader.propTypes = {
    title: PropTypes.string.isRequired,
  };

export default CarouselHeader;
